export const getMainName = (state) => {
  return state.name;
};
